import { createSvgIcon } from '@mui/material';

export const ClockOutlined = createSvgIcon(
  <svg
    viewBox="0 0 20 20"
    fill="none"
    fontSize="25px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
      stroke="#6B7280"
      strokeWidth="2"
    />
  </svg>,
  'ClockOutlined',
);
